<article id="contatti" class="it-page-section anchor-offset richtext-wrapper" *ngIf="data.length > 0">
  <h2 class="mb-3">Contatti</h2>
  <div class="card-wrapper card-teaser-wrapper">
    <div class="card card-teaser card-teaser-info shadow-sm mt-3 rounded" *ngFor="let contact of contacts; let i = index">
      <div class="card-body">
        <ng-container *ngIf="contact.contact_point_body">
          <!-- <p> {{contact.title}} </p> -->
          <p [innerHTML]="sanitizeHtml(contact.contact_point_body.value)"></p>
        </ng-container>
        <div class="card-text">
          <div *ngIf="contact.contact_point_contacts.phone.length">
            <p class="mb-0"><strong class="fw-bold">Telefono:</strong></p>
            <ul>
              <li *ngFor="let phone of contact.contact_point_contacts.phone">
                <a [href]="'tel:' + phone">{{ phone }}</a>
              </li>
            </ul>
          </div>
          <div *ngIf="contact.contact_point_contacts.url.length">
            <p class="mb-0"><strong class="fw-bold">Url:</strong></p>
            <ul>
              <li *ngFor="let url of contact.contact_point_contacts.url">
                <a [href]="url" target="_blank">{{ url }}</a>
              </li>
            </ul>
          </div>
          <div *ngIf="contact.contact_point_contacts.email.length">
            <p class="mb-0"><strong class="fw-bold">Email:</strong></p>
            <ul>
              <li *ngFor="let email of contact.contact_point_contacts.email">
                <a [href]="'mailto:' + email">{{ email }}</a>
              </li>
            </ul>
          </div>
          <div *ngIf="contact.contact_point_contacts.pec.length">
            <p class="mb-0"><strong class="fw-bold">PEC:</strong></p>
            <ul>
              <li *ngFor="let pec of contact.contact_point_contacts.pec">
                <a [href]="'mailto:' + pec">{{ pec }}</a>
              </li>
            </ul>
          </div>
          <div *ngIf="contact.contact_point_contacts.account.length">
            <p class="mb-0"><strong class="fw-bold">Account:</strong></p>
            <ul>
              <li *ngFor="let account of contact.contact_point_contacts.account">{{ account }}</li>
            </ul>
          </div>
          <div *ngIf="contact.contact_point_contacts.linkedin.length">
            <p class="mb-0"><strong class="fw-bold">Linkedin:</strong></p>
            <ul>
              <li *ngFor="let linkedin of contact.contact_point_contacts.linkedin">{{ linkedin }}</li>
            </ul>
          </div>
          <div *ngIf="contact.contact_point_contacts.skype.length">
            <p class="mb-0"><strong class="fw-bold">Skype:</strong></p>
            <ul>
              <li *ngFor="let skype of contact.contact_point_contacts.skype">{{ skype }}</li>
            </ul>
          </div>
          <div *ngIf="contact.contact_point_contacts.telegram.length">
            <p class="mb-0"><strong class="fw-bold">Telegram:</strong></p>
            <ul>
              <li *ngFor="let telegram of contact.contact_point_contacts.telegram">{{ telegram }}</li>
            </ul>
          </div>
          <div *ngIf="contact.contact_point_contacts.twitter.length">
            <p class="mb-0"><strong class="fw-bold">Twitter:</strong></p>
            <ul>
              <li *ngFor="let twitter of contact.contact_point_contacts.twitter">{{ twitter }}</li>
            </ul>
          </div>
          <div *ngIf="contact.contact_point_contacts.whatsapp.length">
            <p class="mb-0"><strong class="fw-bold">Whatsapp:</strong></p>
            <ul>
              <li *ngFor="let whatsapp of contact.contact_point_contacts.whatsapp">{{ whatsapp }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</article>